import {Box, Typography} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import style from './FingerprintLoading.module.css'

type Props = {
    size?: number;       // kích thước icon
    label?: string;      // text dưới icon
    speedSec?: number;   // tốc độ quét
    hint?: string;
    handleShowHint?: (hint: string | null | undefined) => void;
};

export function FingerprintLoading({
                                       size = 88,
                                       label = "Scanning…",
                                       speedSec = 1.4,
                                       hint = "",
                                       handleShowHint = undefined
                                   }: Props) {
    return (

        <Box
            role="status"
            aria-live="polite"
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1.25,
            }}
        >
            <Box>
                <img
                    src="/assets/finger_print_4.png"
                    alt="Start Scam Identification"
                    className={style.fingerprintImage}
                    style={{
                        width: '88px',
                        height: '118px',
                        borderRadius: '45% 52% 43% 43% / 53% 54% 44% 46%'
                    }}
                />
            </Box>

            {label && (
                <Typography
                    sx={{
                        fontFamily: '"Orbitron", sans-serif',
                        fontWeight: 700,
                        color: "#2b2f23",
                        fontSize: {lg:'0.95rem', md:"0.875rem"},
                        letterSpacing: ".5px",
                        textAlign: "center",
                    }}
                >
                    {label}
                    {hint && hint.trim() !== "" && (
                        <HelpOutlineIcon
                            onClick={() => handleShowHint && handleShowHint(hint)}
                            sx={{
                                cursor: "pointer"
                            }}
                        />
                    )}
                </Typography>
            )}
        </Box>

    );
}
